import { Countries, IdentificationFieldSize } from './constants.js';
import RawTextField, { RawTextDefaultProps } from './components/RawTextField.js';
import React__default from 'react';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var NUMERIC_REGEX = /[^0-9]/g;

var removeNonNumbers = function removeNonNumbers(value) {
  return value.replace(NUMERIC_REGEX, '');
};

var IdentificationFieldCountry = Countries;

var IdentificationField = function IdentificationField(_ref) {
  var _ref$country = _ref.country,
      countryProp = _ref$country === void 0 ? 'US' : _ref$country,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? 'Required' : _ref$description,
      _ref$isResizeable = _ref.isResizeable,
      isResizeable = _ref$isResizeable === void 0 ? RawTextDefaultProps.isResizeable : _ref$isResizeable,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? RawTextDefaultProps.size : _ref$size,
      _ref$isRounded = _ref.isRounded,
      isRounded = _ref$isRounded === void 0 ? RawTextDefaultProps.isRounded : _ref$isRounded,
      props = _objectWithoutProperties(_ref, ["country", "description", "isResizeable", "size", "isRounded"]);

  var country = IdentificationField.Countries[countryProp];
  return /*#__PURE__*/React__default.createElement(RawTextField, _extends({}, country, props, {
    isResizeable: isResizeable,
    size: size,
    isRounded: isRounded,
    description: description,
    value: country.format(props.value),
    onChange: function onChange(value, event) {
      return props.onChange(removeNonNumbers(value), value, event);
    },
    maxLength: 11 // 9 #s+ "- -"
    ,
    __focusBehavior: "default"
  }));
};

IdentificationField.Sizes = IdentificationFieldSize;
IdentificationField.Countries = IdentificationFieldCountry;

export { IdentificationFieldCountry, IdentificationField as default };
